import { axiosInstance } from "api/instance";

export const NOTIFICATION_DOMAIN = "notification";

export const NOTIFICATION_DONE_ENDPOINT = "done";

export const notificationApi = {
  done: (pid: string) =>
    axiosInstance.post<void>(
      `${NOTIFICATION_DOMAIN}/${NOTIFICATION_DONE_ENDPOINT}`,
      {
        type: "remind",
      },
      { params: { pid: pid } }
    ),
};